import { useTranslation } from 'react-i18next';

import type { Invoice } from '~/api/invoices/types';

import { AlertDialog, Button } from '~/components';

type Props = {
  invoice: Invoice;
  onClose?: () => void;
};

export const InvoiceAlreadyApprovedDialog = ({ invoice, onClose }: Props) => {
  const { t } = useTranslation(['common', 'invoices']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoices:overview.lockedByAdmin.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {t('invoices:overview.lockedByAdmin.description', { number: invoice.fcEntryNumber })}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <AlertDialog.Close
          render={
            <Button emphasis="status" onClick={onClose}>
              {t('common:ok')}
            </Button>
          }
        />
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
